const PREFIX = 'CLINICS';

export const LIST_CLINICS = `${PREFIX}/LIST`;
export const RETRIEVE_CLINIC = `${PREFIX}/RETRIEVE`;
export const CREATE_CLINIC = `${PREFIX}/CREATE`;
export const UPDATE_CLINIC = `${PREFIX}/UPDATE`;
export const SET_FILTER_CLINIC = `${PREFIX}/SET_FILTER`;
export const DROPDOWN_CLINICS = `${PREFIX}/DROPDOWN`;
export const EXTERNAL_DROPDOWN_CLINICS = `${PREFIX}/EXTERNAL_DROPDOWN`;
